import { Button, styled } from "@mui/material";

/**
 * SoftOrangeButton component is a styled Material-UI Button with custom styles.
 * @param {object} props - Component props.
 * @param {string} [props.width="60%"] - Button width.
 * @param {string} [props.height="66px"] - Button height.
 * @returns {JSX.Element} Styled Material-UI Button component.
 */
export const SoftOrangeButton = styled(Button)(({ width, height }) => ({
  justifyContent: "center",
  alignItems: "center",
  padding: "15px 25px",
  gap: "10px",
  width: width || "60%",
  fontFamily: "Lexend",
  textTransform: "none",
  fontWeight: 500,
  height: height ? height : "66px",
  margin: "2%",
  fontSize: 19,
  border: "2px solid #FF7539",
  backgroundColor: "#F08050",
  color: "#fff",
  borderRadius: "32px",
  boxShadow: "0px 0px 15px 0px #00000040",
  "&:hover": {
    border: "2px solid #FF7539",
    backgroundColor: "#F08050",
    color: "#fff",
    fontFamily: "Lexend",
    textTransform: "none",
    fontWeight: 500,
  },
}));
